<template>
  <button-fragment @click="triggerSideModal" variant="primary">
    <slot></slot>
  </button-fragment>
</template>

<script>
import { ButtonFragment } from "@bvm/forms";
import ChangeCocFormModal from "./ChangeCocFormModal";

export default {
  name: "change-coc-form-modal-button",
  props: {
    modalWidth: {type: String, default: "400px"},
    enableBackdropClose: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ButtonFragment
  },
  methods: {
    triggerSideModal() {
      this.$bvmModal.show(
          ChangeCocFormModal,
        {
          modalWidth: this.modalWidth
        },
        {
          clickToClose: this.enableBackdropClose
        }
      );
    }
  }
};
</script>
